export function createMultiLocationControl({ onLeft, onRight, labelText = 'ALL'}) {
    const container = document.createElement('div');
    container.className = 'location-control-buttons';

    const leftBtn = document.createElement('button');
    leftBtn.textContent = '◀';

    const label = document.createElement('span');
    label.textContent = labelText;

    const rightBtn = document.createElement('button');
    rightBtn.textContent = '▶';

    container.appendChild(leftBtn);
    container.appendChild(label);
    container.appendChild(rightBtn);

    leftBtn.addEventListener('click', () => onLeft?.(label));
    rightBtn.addEventListener('click', () => onRight?.(label));

    return container;
}

export function removeMultiLocationControl(mapAdapter, type = 'multiLocation') {
    const map = mapAdapter.getMapInstance();
    const ctrlArray = map.controls?.[google.maps.ControlPosition.BOTTOM_LEFT];
    if(!ctrlArray) { return; }

    for(let i = ctrlArray.getLength() - 1; i >= 0; i--) {
        const el = ctrlArray.getAt(i);
        if(el?.classList.contains('location-control-button')) {
            ctrlArray.removeAt(el);
        }
    }
}